// repairs/my-model
import { postFormData, createFormData, postData } from 'src/services/RestApi';

export const apiCreate = async (values) => {
  const { formData, queryData } = requestParams(values);
  return await postFormData(
    'api/repair/create',
    formData,
    queryData,
  );
};

export const apiUpdate = async (values) => {
  const { myId, ...newPayload } = values; // Remove myId

  const { formData, queryData } = requestParams(newPayload, true);
  return await postFormData(
    'api/repair/update',
    formData,
    queryData,
  );
};

export const apiRemove = async (values) => {
  return await postData(
    'api/repair/remove',
    {repairId: values.id},
  );
};

export const apiEditPagers = async (values) => {
  const { formData, queryData } = requestPagers(values);
  return await postFormData(
    'api/repair/edit-pagers',
    formData,
    queryData,
  );
};

export const apiPayBill = async (myId) => {
  return await postData(
    'api/repair/paybill',
    {repairId: myId},
  );
};

function requestParams(values, isUpdate = false) {
  const queryData = {};
  if (isUpdate) {
    queryData.repairId = values.id;
  }

  if (values.price) {
    queryData.price = values.price;
  }
  if (values.lastKm) {
    queryData.atKm = values.lastKm;
  }
  if (values.created) {
    queryData.created = values.created;
  }
  if (values.plateField?.value) {
    queryData.carId = values.plateField.value;
    // Save image to folder
    values.saveToFolder = values.plateField.label;
  }
  if (Array.isArray(values.serviceField) && values.serviceField.length > 0) {
    const arrays = values.serviceField
        .filter(item => item && typeof item.value !== "undefined")
        .map(item => item.value);
    if (arrays.length > 0) {
        queryData.services = arrays.join(',');
    }
  }
  if (values.note) {
    queryData.note = values.note;
  }

  const formData = createFormData(values);
  return { formData, queryData };
}

function requestPagers(values) {
  const queryData = {
    carId: values.carId,
    expOn: values.expField,
    serviceId: values.serviceId
  };
  // if (values.field_pagers?.value) {
  //   queryData.serviceId = values.field_pagers.value;
  // }

  values.saveToFolder = values.plate;
  const formData = createFormData(values);
  return { formData, queryData };
}
